import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "creationV2__body creationV2__body--details" }
const _hoisted_2 = { class: "creationV2__scroll-wrapper" }
const _hoisted_3 = { class: "creationV2__container creationV2__container--tight-gap" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col creationV2__container--tight-gap"
}
const _hoisted_5 = { class: "font-bold text-2xl xs:text-3xl lg:text-[3vw] lg:leading-tight text-creation-on-background" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col creationV2__container--tight-gap"
}
const _hoisted_8 = { class: "font-bold text-2xl xs:text-3xl lg:text-[3vw] lg:leading-tight text-creation-on-background" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 2,
  class: "flex flex-col creationV2__container--tight-gap"
}
const _hoisted_11 = { class: "font-bold text-xl xs:text-3xl lg:text-[3vw] lg:leading-tight text-creation-on-background" }
const _hoisted_12 = { class: "flex flex-col creationV2__container--tight-gap" }
const _hoisted_13 = { class: "creation__form-checkbox" }
const _hoisted_14 = {
  key: 0,
  for: "terms"
}
const _hoisted_15 = { class: "mt-0.5 relative inline-flex items-center justify-center self-start" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", { class: "custom-checkbox icon text-creation-background w-3.5 h-3.5 lg:w-[calc(16px+0.2vw)] lg:h-[calc(16px+0.2vw)] stroke-[3] absolute" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#check" })
], -1)
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "creation__form-checkbox" }
const _hoisted_19 = {
  key: 0,
  for: "privacy"
}
const _hoisted_20 = { class: "mt-0.5 relative inline-flex items-center justify-center self-start" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", { class: "custom-checkbox icon text-creation-background w-3.5 h-3.5 lg:w-[calc(16px+0.2vw)] lg:h-[calc(16px+0.2vw)] stroke-[3] absolute" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#check" })
], -1)
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "flex justify-end sticky bottom-0" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "button button--circle-creation opacity-0 pointer-events-none" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("svg", { class: "button__icon stroke-2" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#arrow-right" })
], -1)
const _hoisted_26 = [
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        appear: "",
        name: "custom-classes",
        "enter-active-class": "animate__fadeInUp",
        onAfterEnter: _ctx.afterTransitionEntered
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.next()), ["prevent"]))
            }, [
              _createVNode(_Transition, {
                appear: "",
                mode: "out-in",
                name: "custom-classes",
                "enter-active-class": "animate__fadeInUp",
                onAfterEnter: _ctx.afterTransitionEntered
              }, {
                default: _withCtx(() => [
                  (_ctx.showField === 'name')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('survey.agentNameMessage')), 1),
                        _withDirectives(_createElementVNode("input", {
                          ref: "name",
                          class: "creation__form-input",
                          type: "text",
                          placeholder: _ctx.$t('survey.nameFieldPlaceholder'),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
                        }, null, 8, _hoisted_6), [
                          [_vModelText, _ctx.name]
                        ])
                      ]))
                    : (_ctx.showField === 'email')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t('survey.agentEmailMessage')), 1),
                          _withDirectives(_createElementVNode("input", {
                            ref: "email",
                            class: "creation__form-input",
                            type: "email",
                            placeholder: _ctx.$t('survey.emailFieldPlaceholder'),
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event))
                          }, null, 8, _hoisted_9), [
                            [_vModelText, _ctx.email]
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.$t('survey.agentTermsMessage')), 1),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              (_ctx.campaign.enforcesTermsAndConditionsConsent)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.termsConfirmed) = $event)),
                                        id: "terms",
                                        ref: "terms",
                                        tabindex: "1"
                                      }, null, 512), [
                                        [_vModelCheckbox, _ctx.termsConfirmed]
                                      ]),
                                      _hoisted_16
                                    ]),
                                    _createElementVNode("span", { innerHTML: _ctx.termsAndConditionsConsentText }, null, 8, _hoisted_17)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              (_ctx.campaign.enforcesPrivacyPolicyConsent)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.privacyConfirmed) = $event)),
                                        id: "privacy",
                                        ref: "privacy",
                                        tabindex: "2"
                                      }, null, 512), [
                                        [_vModelCheckbox, _ctx.privacyConfirmed]
                                      ]),
                                      _hoisted_21
                                    ]),
                                    _createElementVNode("span", { innerHTML: _ctx.privacyPolicyText }, null, 8, _hoisted_22)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                ]),
                _: 1
              }, 8, ["onAfterEnter"])
            ], 32),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_Transition, {
                name: "custom-classes",
                "enter-active-class": "animate__fadeInUp",
                "leave-active-class": "animate__fadeOutDown"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "submit",
                    class: _normalizeClass([{'button--circle-disabled': !_ctx.showNextButton}, "button button--circle-creation button--circle-creation-primary"]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.next())),
                    tabindex: "5"
                  }, _hoisted_26, 2)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["onAfterEnter"])
    ])
  ]))
}